angular.module("vgresiduos").factory("rootScopeService", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		const _disposalPreferences = {
			get: function () {
				return $rootScope.clientDisposalPreferences;
			},
			set: function (disposalPreferences) {
				$rootScope.clientDisposalPreferences = disposalPreferences;
			}
		};

		const _storagePreferences = {
			get: function () {
				return $rootScope.storagePreferences;
			},
			set: function (storagePreferences) {
				$rootScope.storagePreferences = storagePreferences;
			}
		};

		const _stockPreferences = {
			get: function () {
				return $rootScope.stockControlPreferences;
			},
			set: function (stockControlPreferences) {
				$rootScope.stockControlPreferences = stockControlPreferences;
			}
		};

		return {
			getDisposalPreferences: _disposalPreferences.get,
			setDisposalPreferences: _disposalPreferences.set,
			getStoragePreferences: _storagePreferences.get,
			setStoragePreferences: _storagePreferences.set,
			getStockControlPreferences: _stockPreferences.get,
			setStockControlPreferences: _stockPreferences.set
		};
	}
]);
